import React from 'react';
import Table from '../../../../components/_table/Table/Table';
import Panel from '../../../../components/outline/Panel';
import { columns } from './columns';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';
import {
  COUPON_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL,
  COUPON_ISSUE_HISTORY_DETAIL_SORT_OPTION_MODEL,
} from '../../../../store/modules/coupon/models';

const CouponIssueHistoryDetailItemList = (props) => {
  const { couponIssueHistoryItemList, getCouponIssueHistoryCouponGeneratedList, filterOption, sortOption, pagination } =
    props;

  return (
    <Panel className="coupon-issue-history-detail-item-list">
      <div className="panel-header">
        <div className="title">쿠폰 발급 내역 아이템 리스트</div>
      </div>

      <div className="panel-body">
        <Table
          columns={(utils) =>
            columns({
              ...utils,
              isFilter: true,
            })
          }
          rowKey={(record) => record.id}
          list={couponIssueHistoryItemList}
          getList={(option) =>
            getCouponIssueHistoryCouponGeneratedList({
              ...option,
            })
          }
          filterOption={filterOption}
          sortOption={sortOption}
          pagination={pagination}
          initialOption={{
            filterOption: COUPON_ISSUE_HISTORY_DETAIL_FILTER_OPTION_MODEL,
            sortOption: COUPON_ISSUE_HISTORY_DETAIL_SORT_OPTION_MODEL,
            pagination: _LIST_PAGINATION_MODEL,
          }}
          size="small"
          scroll={{ x: true }}
          bordered={true}
        />
      </div>
    </Panel>
  );
};

export default CouponIssueHistoryDetailItemList;
